import config from 'Config/appConfig';
import util from 'Utils/object';

/**
 * parse and convert query strings into their short version
 * @param  {string} query     query to parse and convert
 * @param  {boolean} unparse  go from short version to long version of querystring
 * @return {string}           shortened query
 */
function queryParser(query = '', unparse = false) {
  const matchers = (!unparse) ?
    config.queryMatches :
    util.swapKV(config.queryMatches);

  // Supprts query string starting with a ? or not (we strip it),
  // if no ? we need to break the refs
  const qs = '?' === query[0] ? query.slice(1) : query.slice();
  // Split about the query string
  return qs.split('&')
    .map((str) => str.split('='))
    .map(([key, val]) => (
      matchers[key] ? [matchers[key], val] : [key, val]
    ))
    .map((str) => str.join('='))
    .join('&');
}

// Curried for ease
export const shorten = (query) => queryParser(query, false);
export const lengthen = (query) => queryParser(query, true);

export default {
  shorten,
  lengthen,
};



// WEBPACK FOOTER //
// ./app/utils/query/queryParser.js